/**
 * Audit UI Phase 1 — 메인 페이지 (속견표 + 검색 + 부·류).
 *
 * URL: /?audit=main
 * 액션:
 *   - 검색 → /?audit=results&q=...&scope=...
 *   - chapter 클릭 → /?audit=chapter&ch=NN
 */
import React from "react";
import SearchBar from "./SearchBar";
import QuickReferenceGrid from "./QuickReferenceGrid";
import SectionChapterHierarchy from "./SectionChapterHierarchy";
import AuditSideNav from "./AuditSideNav";
import "./theme.css";

function navigate(url) {
  window.history.pushState({}, "", url);
  window.dispatchEvent(new PopStateEvent("popstate"));
}

export default function MainPage() {
  const onSearch = ({ q, scope }) => {
    navigate(`/?audit=results&q=${encodeURIComponent(q)}&scope=${scope}`);
  };
  const onChapterJump = (ch) => {
    navigate(`/?audit=chapter&ch=${ch}`);
  };

  return (
    <div
      className="audit-root"
      style={{
        minHeight: "100vh",
        background: "var(--audit-bg)",
        display: "flex",
      }}
    >
      <AuditSideNav />
      <div style={{ flex: 1, minWidth: 0 }}>
        <SearchBar onSearch={onSearch} onChapterJump={onChapterJump} />
        <div style={{ padding: 24, maxWidth: 1200, margin: "0 auto" }}>
          <QuickReferenceGrid onChapterClick={onChapterJump} />
          <SectionChapterHierarchy onChapterClick={onChapterJump} />
        </div>
      </div>
    </div>
  );
}
